module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_yoso_studio-faee94237082c88df7fb2c018f2440ff.webp";